// Servicio de operaciones de administración (CRUD de publicaciones).
// Todas las llamadas adjuntan el JWT en el header Authorization.

import { getToken, logout } from './authService';

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = (extra = {}) => {
  const token = getToken();
  return {
    ...extra,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

// Maneja respuestas: lanza error con mensaje del backend si lo hay; cierra sesión en 401.
const handle = async (response) => {
  if (response.status === 401) {
    logout();
    throw new Error('Sesión expirada. Inicia sesión nuevamente.');
  }
  if (!response.ok) {
    let mensaje = 'Ocurrió un error en la operación';
    try {
      const data = await response.json();
      mensaje = data.mensaje || mensaje;
    } catch {
      /* sin cuerpo JSON */
    }
    throw new Error(mensaje);
  }
  if (response.status === 204) return null;
  return response.json();
};

// --- Categorías ---
export const getCategoriasAdmin = async (institucionSlug) => {
  const response = await fetch(`${API_URL}/api/admin/categorias/${institucionSlug}`, {
    headers: authHeaders(),
  });
  return handle(response);
};

// datos: { nombre, descripcion, padreId, orden, tipoOrden }
export const crearCategoria = async (institucionSlug, datos) => {
  const response = await fetch(`${API_URL}/api/admin/categorias/${institucionSlug}`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(datos),
  });
  return handle(response);
};

export const actualizarCategoria = async (id, datos) => {
  const response = await fetch(`${API_URL}/api/admin/categorias/${id}`, {
    method: 'PUT',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(datos),
  });
  return handle(response);
};

export const cambiarEstadoCategoria = async (id, activo) => {
  const response = await fetch(`${API_URL}/api/admin/categorias/${id}/estado`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ activo }),
  });
  return handle(response);
};

export const eliminarCategoria = async (id) => {
  const response = await fetch(`${API_URL}/api/admin/categorias/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  return handle(response);
};

// --- Publicaciones ---
export const getPublicacionesAdmin = async (categoriaId) => {
  const query = categoriaId ? `?categoriaId=${categoriaId}` : '';
  const response = await fetch(`${API_URL}/api/admin/publicaciones${query}`, {
    headers: authHeaders(),
  });
  return handle(response);
};

export const getPublicacionAdmin = async (id) => {
  const response = await fetch(`${API_URL}/api/admin/publicaciones/${id}`, {
    headers: authHeaders(),
  });
  return handle(response);
};

export const crearPublicacion = async (formData) => {
  const response = await fetch(`${API_URL}/api/admin/publicaciones`, {
    method: 'POST',
    headers: authHeaders(), // NO fijar Content-Type: el navegador define el boundary multipart
    body: formData,
  });
  return handle(response);
};

export const actualizarPublicacion = async (id, formData) => {
  const response = await fetch(`${API_URL}/api/admin/publicaciones/${id}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: formData,
  });
  return handle(response);
};

export const cambiarEstadoPublicacion = async (id, activo) => {
  const response = await fetch(`${API_URL}/api/admin/publicaciones/${id}/estado`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ activo }),
  });
  return handle(response);
};

export const eliminarPublicacion = async (id) => {
  const response = await fetch(`${API_URL}/api/admin/publicaciones/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  return handle(response);
};
